import React, { useState, useEffect, useRef } from "react";
import { APIProvider, Map } from "@vis.gl/react-google-maps";
import { CarMarkers } from "./CarMarkers";
import { CarInfo } from "./CarInfo";
import { ActionZones } from "./ActionZones";
import { SiteAreaMarkers } from "./SiteAreaMarkers";
import { SiteArea } from "./SiteArea";
import { useTranslation } from "react-i18next";
import { useHookstate } from "@hookstate/core";
import { MapInitializer } from "./MapInitializer";
import { FilterHeader } from "pages/Map/MapStyled";
import {
    MAP_GLOBAL_STATES,
    COMMON_COMPONENTS_STATES,
    SITELOCATION_GLOBAL_STATE,
    SITEID_GLOBAL_STATE,
    SiteSetupAction
} from "globalStore/globalStore";
import CarList from "../CarList";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { getCarPathActionZoneAction } from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import {
    siteSettingsTypes,
    settingsPoITypes,
    isUserBasic,
    isUserReadOnly
} from "constant";
import MapMobileMenu from "../MapMobileMenu";
import MapTopMenu from "../MapTopMenu";
import MapSideMenu from "../MapSideMenu";
import MapLegend from "../MapLegend";
import { checkZoom } from "../functions/checkZoom";
import { checkCenterLat } from "../functions/checkCenterLat";
import { checkCenterLng } from "../functions/checkCenterLng";
import { displayCars } from "../functions/displayCars";
import { getCourseExtents } from "../functions/getCourseExtents";
import { handleOpen2 } from "../functions/events/handleOpen2";
import { resetPrevPolygon } from "../functions/resetPrevPolygon";
import { drawMarker } from "../functions/events/drawMarker";
import { getMapBoundsForSite } from "../functions/getMapBoundsForSite";
import { Modal } from "@mui/material";
import { PopUpContainer } from "assets/css/globle";
import { Box } from "@mui/system";
import MapBottom from "../MapBottom";
import { MapControlButtons } from "../../Map/MapControlButtons";
import MapTiltButton from "../../Map/MapTiltButton";
import { Loader } from "commonComponents/Loader/Loader";

export const GoogleMap = () => {
    const { t } = useTranslation();

    const {
        siteLocationsData,
        siteSetupData,
        mapInformationData,
        siteSettingsData,
        getUserRole,
        kmlLayerData,
        mapImageData,
        mapXYPointsData,
        getVisagaUsersListAction
    } = useSelector((state) => state.commonReducers) || [];

    const {
        showTeeMarkers,
        showPointsOfInterest,
        imageUrl,
        imageHoleNo,
        addSiteSetup,
        courseNo,
        typeHole,
        holeNum,
        editSiteSetup,
        addSelectType,
        areaModified
    } = useHookstate(SiteSetupAction);

    const { siteLocationGlobalData, singleSiteLocationData } = useHookstate(SITELOCATION_GLOBAL_STATE);

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const {
        mapSideNavTabState,
        enableClickToDriveFeature,
        showTaggedCarArrayClickToDriveInputValueSetter,
        previousEditedPolygon,
        heightMapToggle,
        clickWindowState,
        carPopupClickEvent,
        courseExtents
    } = useHookstate(MAP_GLOBAL_STATES);

    const { detectScreenState, showTagCarsState } = useHookstate(COMMON_COMPONENTS_STATES);

    const dispatch = useDispatch();

    const siteLocationGlobalDataValue = siteLocationGlobalData.get();
    const singleSiteLocationDataValue = singleSiteLocationData.get();
    const siteIdValue = siteId.get();
    const editSiteSetupValue = editSiteSetup.get();

    const opacityContainerRef = useRef(null);
    const opacitySliderRef = useRef(null);

    //#region Map
    const [mapReady, setMapReady] = useState(false);
    const [mapData, setMap] = useState(null);
    const [mapsData, setMaps] = useState(null);
    const [mapBaseType, setMapBaseType] = useState(localStorage.getItem("mapBaseType") ?? "");
    const [showMapTerrain, setShowMapTerrain] = useState(localStorage.getItem("mapTerrain") != null ? localStorage.getItem("mapTerrain") == "true" : false);
    const [lastSelectedMapBaseType, setLastSelectedMapBaseType] = useState("");
    const [showMapLabels, setShowMapLabels] = useState(localStorage.getItem("mapLabels") != null ? localStorage.getItem("mapLabels") == "true" : false);
    const [mapTilted, setMapTilted] = useState(false);
    const [heightMapOverlayView, setHeightMapOverlayView] = useState(null);
    const [heightMapInfo, setHeightMapInfo] = useState([]);
    const [openHeightMapModal, setOpenHeightMapModal] = useState(false);
    const [isHeightMapShowing, setIsHeightMapShowing] = useState(false);
    const [dragCenter, setDragCenter] = useState({ lat: 30.20223435690779, lng: -81.39747201448188 });
    const [goClick, setGoClick] = useState(false);
    const [center, setCenter] = useState({ lat: 0, lng: 0 });
    const [lat, setLat] = useState('');
    const [lng, setLng] = useState('');
    const [isValidLat, setIsValidLat] = useState("");
    const [isValidLng, setIsValidLng] = useState("");
    const [openSiteExtent, setOpenSiteExtent] = useState(false);
    const [setting, setSetting] = useState({ draggable: true });
    const [clickState, setClickState] = useState({});
    const [site, setSite] = useState(true);
    const [zoomPosition, setZoomPosition] = useState(null);
    //#endregion Map

    //#region Car
    const [carData, setCarData] = useState([]);
    const [isActiveCarList, setActiveCarList] = useState("false");
    const [carSnackbarInfo, setCarSnackbarInfo] = useState({
        lat: "",
        lng: "",
    });
    const [snackbarState, setSnackbarState] = useState({
        openSnackbar: false,
        vertical: "bottom",
        horizontal: "right",
    });
    //#endregion Car

    //#region Site Area
    const [showHoleMarker, setShowHoleMarker] = useState(true);
    const [CTDModal, setCTDModal] = useState(false);
    const [zoomToShowAll, setZoomToShowAll] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [teeEditValue, setTeeEditValue] = useState(1323);
    const [siteSetupDialogBox, setSiteSetupDialogBox] = useState({});
    const [teeMarkersDataState, setTeeMarkersDataState] = useState([]);
    const [pointsOfInterestDataState, setPointsOfInterestDataState] = useState([]);
    const [centerGreenDataState, setCenterGreenDataState] = useState([]);
    const [modalState, setModalState] = useState("");
    const [openModel, setOpenModel] = useState(false);
    const [openAreaWindow, setOpenAreaWindow] = useState(false);
    const [courseEditName, setCourseEditName] = useState(1);
    const [holeCount, setHoleCount] = useState(null);
    const [editHoleNo, setEditHoleNo] = useState(0);
    const [teeEditCopy, setTeeEditCopy] = useState(0);
    const [holeNo, setHoleNo] = useState();
    const [editId, setEditId] = useState(0);
    const [poiEditTypeCopy, setPoiEditTypeCopy] = useState(2);
    const [poiEditPositionCopy, setPoiEditPositionCopy] = useState(0);
    const [poiEditTypeValue, setPoiEditTypeValue] = useState(2);
    const [poiEditPositionValue, setPoiEditPositionValue] = useState(0);
    const [editLatLng, setEditLatLng] = useState({ lat: 0, lng: 0 });
    const [deleteId, setDeleteId] = useState(0);
    const [openSiteAreaWindow, setOpenSiteAreaWindow] = useState(false);
    const [tempPolygon, setTempPolygon] = useState([]);
    const [siteAreaSaveActiveButton, setSiteAreaSaveActiveButton] = useState(false);
    const [verticesCount, setVerticesCount] = useState(0);
    const [editCogTeePoiSaveActiveButton, setEditCogTeePoiSaveActiveButton] = useState(false);
    const [addCogTeePoiSaveActiveButton, setAddCogTeePoiSaveActiveButton] = useState(false);
    const [teeMarkeSeetingId, setTeeMarkerSeetingId] = useState([]);
    const [ourData, setOurData] = useState({ tee: [], poi: [], cog: [] });
    const [alertModalHandleOnSubmit, setAlertModalHandleOnSubmit] = useState(() => { });
    const [alertModalIsOpen, setAlertModalIsOpen] = useState(false);
    const [alertModalHandleOnClose, setAlertModalHandleOnClose] = useState(() => { });
    const [alertModalTitle, setAlertModalTitle] = useState("");
    const [alertModalContent, setAlertModalContent] = useState("");
    const [alertModalValidation, setAlertModalValidation] = useState(false);
    const [removeAddPolygon, setRemoveAddPolygon] = useState(false);
    const [finalDataState, setFinalDataState] = useState();
    const [poiTypeValue, setPoiTypeValue] = useState(2);
    const [poiPositionValue, setPoiPositionValue] = useState(0);
    const [teeValue, setTeeValue] = useState(1323);
    const [isHole, setIsHole] = useState(false);
    const [isEditHole, setIsEditHole] = useState(false);
    const [indexId, setIndexID] = useState();
    const [tempSiteId, setTempSiteId] = useState("");
    const [courseTypeModel, setCourseTypeModel] = useState(1);
    const [siteAreaClickEvent, setSiteAreaClickEvent] = useState();
    const [siteAreaClickEventData, setSiteAreaClickEventData] = useState();
    const [isSiteAreaPolygon, setIsSiteAreaPolygon] = useState(false);
    const [tempSiteData, setTempSiteData] = useState([]);
    const [tempSiteEdit, setTempSiteEdit] = useState([]);
    const [isTempPolygon, setIsTempPolygon] = useState(false);
    const [siteSetupSaveActiveButton, setSiteSetupSaveActiveButton] = useState(false);
    const [isHoleAreaPolygon, setIsHoleAreaPolygon] = useState(false);
    const [editModel, setEditModel] = useState(false);
    const [siteSetupState, setSiteSetupState] = useState([]);
    const [editSelectedData, setEditSelectedData] = useState();
    const [areaPolygons, setAreaPolygons] = useState([]);
    const [holePolygons, setHolePolygons] = useState([]);
    const [courseNameModel, setCourseNameModel] = useState(1);
    const [holeNoModel, setHoleNoModel] = useState(1);
    const [siteDrawAreaPolygon, setSiteDrawAreaPolygon] = useState();
    const [drawAreaPolygon, setDrawAreaPolygon] = useState();

    // teesBtn
    const [teesAreaPathState, setTeesAreaPathState] = useState();
    const [teesPathCoordsState, setTeesPathCoords] = useState();
    const [teesZoneDisplayed, setTeesZoneDisplayed] = useState([]);

    // gmsBtn
    const [gmsAreaPathState, setGmsAreaPathState] = useState();
    const [gmsPathCoordsState, setGmsPathCoords] = useState();
    const [gmsZoneDisplayed, setGmsZoneDisplayed] = useState([]);

    //fwysBtn
    const [fwysAreaPathState, setFwysAreaPathState] = useState();
    const [fwysPathCoordsState, setFwysPathCoords] = useState();
    const [fwysZoneDisplayed, setFwysZoneDisplayed] = useState([]);

    //extsBtn
    const [extsAreaPathState, setExtsAreaPathState] = useState();
    const [extsPathCoordsState, setExtsPathCoords] = useState();
    const [extsZoneDisplayed, setExtsZoneDisplayed] = useState([]);


    const [stgsAreaPathState, setStgsAreaPathState] = useState();
    const [stgsPathCoordsState, setStgsPathCoords] = useState();
    const [stgsZoneDisplayed, setStgsZoneDisplayed] = useState([]);
    //#endregion Site Area

    const privilege = getVisagaUsersListAction && getVisagaUsersListAction.length > 0 && getVisagaUsersListAction?.filter((a) => a.username === getUserRole.Name);
    const canAccessSiteSetup = privilege && privilege.length > 0 && privilege[0].SiteSetup;
    const isMobile = window.innerWidth < 850;

    const handleMapTypeId = () => {
        let mapTypeId = "satellite";

        if (mapBaseType === "satellite") {
            mapTypeId = showMapLabels ? "hybrid" : "satellite";
        }
        else if (mapBaseType === "roadmap") {
            mapTypeId = showMapTerrain ? "terrain" : "roadmap";
        }
        else if (lastSelectedMapBaseType === "satellite") {
            mapTypeId = showMapLabels ? "hybrid" : "satellite";
        }
        else if (showMapTerrain) {
            mapTypeId = "terrain";
        }
        else {
            mapTypeId = localStorage.getItem("mapBaseType") || "satellite";
        }

        return mapTypeId;
    }

    useEffect(() => {
        if (!mapData) return;

        if (Object.keys(siteLocationsData).length > 0 && mapData && mapsData) {
            const singleLocationLat = siteLocationsData?.filter((item) => item.Id === Number(siteIdValue));

            const centerLocal = {
                lat: checkCenterLat(showHoleMarker, singleSiteLocationDataValue, site, singleLocationLat, carData),
                lng: checkCenterLng(showHoleMarker, singleSiteLocationDataValue, site, singleLocationLat, carData),
            };

            const isValidLat = typeof centerLocal.lat === 'number' && centerLocal.lat >= -90 && centerLocal.lat <= 90 && centerLocal.lat != 0;
            const isValidLng = typeof centerLocal.lng === 'number' && centerLocal.lng >= -180 && centerLocal.lng <= 180 && centerLocal.lng != 0;

            mapData.setZoom(checkZoom(siteLocationGlobalDataValue, singleSiteLocationDataValue, site));

            if (editSiteSetupValue) {
                mapData.panTo(dragCenter);
            } else if (goClick && center?.lat) {
                mapData.panTo(center);
            } else if (isValidLat && isValidLng) {
                mapData.panTo(centerLocal);
            }
        }
    }, [siteLocationsData, mapData, siteIdValue]);

    useEffect(() => {
        if (siteIdValue) {
            dispatch(COMMON_SERVICES.getKmlLayerService(siteIdValue));
            dispatch(COMMON_SERVICES.getHoleMarkerServices(siteIdValue));
            dispatch(getCarPathActionZoneAction([]));
            dispatch(COMMON_SERVICES.getActionZoneServices(siteIdValue));
            dispatch(COMMON_SERVICES.getCarServices(true, siteIdValue));
            dispatch(COMMON_SERVICES.getSiteSettingsServices(siteIdValue));
            dispatch(COMMON_SERVICES.getMapImageServices(siteIdValue));
            dispatch(COMMON_SERVICES.getVisageUsersList());
            dispatch(COMMON_SERVICES.getRolesListServices());
            dispatch(COMMON_SERVICES.getPrivilegesListServices());
            dispatch(COMMON_SERVICES.getVisageUsersServices());
            dispatch(COMMON_SERVICES.getCarTracksServices({ hoursBack: 1 }, siteIdValue));
        }

        addSiteSetup.set(false);

        if (heightMapOverlayView != null) {
            heightMapOverlayView.hide();
        }

        heightMapToggle.set(false);
        setOpenHeightMapModal(false);
        setIsHeightMapShowing(false);
        setHeightMapOverlayView(null);
        setHeightMapInfo("");
    }, [siteIdValue, siteLocationsData]);

    useEffect(() => {
        if (mapData) {
            mapData.setMapTypeId(handleMapTypeId());
        }
    }, [handleMapTypeId()]);

    useEffect(() => {
        detectScreenState.set("map");
        showTagCarsState.set(false);
    }, []);

    useEffect(() => {
        if (site && mapData && mapsData) {
            getMapBoundsForSite(mapData, mapsData, siteSettingsData);
        }
    }, [site]);

    useEffect(() => {
        if (mapsData && mapImageData && Object.keys(mapImageData)?.length > 0 && opacityContainerRef.current) {
            const bounds = new mapsData.LatLngBounds(
                new mapsData.LatLng(mapImageData.SwLat, mapImageData.SwLng), //Southwest corner
                new mapsData.LatLng(mapImageData.NeLat, mapImageData.NeLng) //Northeast corner
            );

            setHeightMapOverlayView(heightMapOverlay(bounds, mapImageData.Image));
        }
    }, [mapsData, mapData, mapImageData, opacityContainerRef.current]);

    useEffect(() => {
        if (heightMapToggle.get() != null && mapsData && mapData) {
            if (heightMapToggle.get() && heightMapOverlayView != null) {
                heightMapOverlayView.toggle();
            }

            heightMapToggle.set(false);

            mapsData.event.addListener(mapData, "click", function (event) {
                handleHeightMapValues(event);
            });
        }
    }, [heightMapToggle.get()]);

    useEffect(() => {
        if (mapXYPointsData && Object.keys(mapXYPointsData)?.length > 0) {
            const img = document.getElementById("heightMapImage");

            if (img == null) {
                return;
            }

            // Create a canvas to extract pixel data
            const canvas = document.createElement('canvas');
            canvas.width = mapImageData.ImageWidth;
            canvas.height = mapImageData.ImageHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            let blueValue = 0;
            if (mapXYPointsData.X >= 0 &&
                mapXYPointsData.Y >= 0 &&
                mapXYPointsData.X < canvas.width &&
                mapXYPointsData.Y < canvas.height) {
                const pixelData = ctx.getImageData(mapXYPointsData.X, mapXYPointsData.Y, 1, 1).data;
                blueValue = pixelData[2];
            }

            const elevationRange = mapImageData.MaxElevation - mapImageData.MinElevation; // 40

            // Map blue value to elevation
            const mappedElevation = mapToElevation(blueValue, mapImageData.MinElevation, elevationRange);

            const updatedInfoArray = heightMapInfo;

            if (updatedInfoArray.length > 0) {
                updatedInfoArray[2] = `X Pixel: ${mapXYPointsData.X}`;
                updatedInfoArray[3] = `Y Pixel: ${mapXYPointsData.Y}`;
                updatedInfoArray[4] = `Grey scale: ${blueValue}`;
                updatedInfoArray[7] = `Elevation: ${mappedElevation.toFixed(2)} meters`;


                setHeightMapInfo(updatedInfoArray);
                setOpenHeightMapModal(true);
            }
        }
    }, [mapXYPointsData, heightMapInfo]);

    useEffect(() => {
        if (mapInformationData?.Data) {
            imageUrl.set(mapInformationData?.Data);
        }
    }, [mapInformationData]);

    const toggleShowHoleMarker = () => {
        dispatch(COMMON_SERVICES.getHoleMarkerServices(siteId.get()));
        setShowHoleMarker(!showHoleMarker);
    }

    const clickToDrivefeature = (event) => {
        let siteIdGet = siteId.get();

        if (showTaggedCarArrayClickToDriveInputValueSetter.get().length !== 0 && enableClickToDriveFeature.get()) {
            let carIdArray = [...showTaggedCarArrayClickToDriveInputValueSetter.get()];

            let carIds = carIdArray.toString();
            let carLat = event.latLng.lat();
            let carLng = event.latLng.lng();

            if (carIds && carLat && carLng) {
                setCarSnackbarInfo({
                    lng: carLng,
                    lat: carLat,
                });

                dispatch(COMMON_SERVICES.setClickToDriveServices(carIds, carLat, carLng, siteIdGet));

                setSnackbarState({ ...snackbarState, openSnackbar: true });
            }
        } else {
            if (enableClickToDriveFeature.get()) {
                setCTDModal(true);
            }
        }
    }

    const handleGoButtonClick = () => {
        const latitude = parseFloat(lat);
        const longitude = parseFloat(lng);

        if (!isNaN(latitude) && !isNaN(longitude)) {
            setIsValidLat("");
            setIsValidLng("");
            setGoClick(true);
            setCenter({ lat: latitude, lng: longitude });
        } else {
            isNaN(latitude) ? setIsValidLat(<p style={{ color: "red" }}>{t("Invalid_Latitude")}</p>) : setIsValidLat("");
            isNaN(longitude) ? setIsValidLng(<p style={{ color: "red" }}>{t("Invalid_Longitude")}</p>) : setIsValidLng("");
        }
    }

    const handleSetSiteExtentClick = () => {
        const bounds = mapData?.getBounds();
        var ne = bounds.getNorthEast();
        var sw = bounds.getSouthWest();
        var ulLat = ne.lat();
        var ulLong = sw.lng();
        var lrLat = sw.lat();
        var lrLong = ne.lng();

        var fudgeX = (lrLong - ulLong) / 10.0;
        var fudgeY = (ulLat - lrLat) / 10.0;
        let payload = {
            SiteId: siteId.get(),
            ULlatitude: ulLat - fudgeY,
            ULlongitude: ulLong + fudgeX,
            LRlatitude: lrLat + fudgeY,
            LRlongitude: lrLong - fudgeX
        };
        dispatch(COMMON_SERVICES.setSiteExtentsServices(payload))
            .then(() => {
                setOpenSiteExtent(false);
                getCourseExtents(siteSettingsData, mapsData, courseExtents);
                dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
            });
    }

    const heightMapOverlay = (bounds, image) => {
        if (!opacitySliderRef.current) return;

        let heightMap = null;

        if (mapsData) {
            heightMap = class Overlay extends mapsData.OverlayView {
                bounds;
                image;
                div;
                constructor(bounds, image) {
                    super();
                    this.bounds = bounds;
                    this.image = image;
                }
                /**
                 * onAdd is called when the map's panes are ready and the overlay has been
                 * added to the map.
                 */
                onAdd() {
                    this.div = document.createElement("div");
                    this.div.id = `heightMapImageDiv${siteId.get()}`;
                    this.div.style.borderStyle = "none";
                    this.div.style.borderWidth = "0px";
                    this.div.style.position = "absolute";
                    this.div.style.visibility = "hidden";

                    // Create the img element and attach it to the div.
                    const img = document.createElement("img");
                    img.id = "heightMapImage";
                    img.src = this.image;
                    img.style.width = "100%";
                    img.style.height = "100%";
                    img.style.position = "absolute";
                    img.style.opacity = "68%"
                    this.div.appendChild(img);

                    const opacitySlider = opacitySliderRef.current;

                    if (opacitySlider) {
                        opacitySlider.min = "0";
                        opacitySlider.max = "100";
                        opacitySlider.value = "68";
                        opacitySlider.style.appearance = 'none';
                        opacitySlider.style.backgroundColor = 'white';
                        opacitySlider.style.visibility = "hidden";

                        opacitySlider.addEventListener("input", () => {
                            const opacityValue = opacitySlider.value / 100;
                            img.style.opacity = opacityValue;
                        });

                        if (opacityContainerRef) {
                            opacityContainerRef.current.appendChild(opacitySlider);
                        }
                    }

                    // Add the element to the "overlayLayer" pane.
                    const panes = this.getPanes();

                    panes.overlayLayer.appendChild(this.div);
                }
                draw() {
                    // We use the south-west and north-east
                    // coordinates of the overlay to peg it to the correct position and size.
                    // To do this, we need to retrieve the projection from the overlay.
                    const overlayProjection = this.getProjection();
                    // Retrieve the south-west and north-east coordinates of this overlay
                    // in LatLngs and convert them to pixel coordinates.
                    // We'll use these coordinates to resize the div.
                    const sw = overlayProjection.fromLatLngToDivPixel(
                        this.bounds.getSouthWest(),
                    );
                    const ne = overlayProjection.fromLatLngToDivPixel(
                        this.bounds.getNorthEast(),
                    );

                    // Resize the image's div to fit the indicated dimensions.
                    if (this.div) {
                        this.div.style.left = sw.x + "px";
                        this.div.style.top = ne.y + "px";
                        this.div.style.width = ne.x - sw.x + "px";
                        this.div.style.height = sw.y - ne.y + "px";
                    }
                }
                hide() {
                    const getHeightMapDiv = document.getElementById(`heightMapImageDiv${siteId.get()}`);
                    if (getHeightMapDiv) {
                        getHeightMapDiv.style.visibility = "hidden";
                    }

                    const opacitySlider = opacitySliderRef.current;
                    if (opacitySlider) {
                        opacitySlider.style.visibility = "hidden";
                    }

                    setIsHeightMapShowing(false);
                }
                show() {
                    const getHeightMapDiv = document.getElementById(`heightMapImageDiv${siteId.get()}`);
                    if (getHeightMapDiv) {
                        getHeightMapDiv.style.visibility = "visible";
                    }

                    const opacitySlider = opacitySliderRef.current;
                    if (opacitySlider) {
                        opacitySlider.style.visibility = "visible";
                    }

                    setIsHeightMapShowing(true);
                }
                toggle() {
                    const getHeightMapDiv = document.getElementById(`heightMapImageDiv${siteId.get()}`);
                    if (getHeightMapDiv) {
                        if (getHeightMapDiv.style.visibility === "hidden") {
                            this.show();
                        } else {
                            this.hide();
                        }
                    }
                }
            }
        }

        let overlay = new heightMap(bounds, image);
        overlay?.setMap(mapData)
        return overlay;
    }

    const handleHeightMapValues = (event) => {
        let clickedLocation = event.latLng;
        const lat = clickedLocation.lat();
        const lng = clickedLocation.lng();

        const mapImageXYPointsRequest = {
            SiteId: parseInt(siteId.get()),
            Latitude: lat,
            Longitude: lng,
            XScale: mapImageData.XScale,
            XRotate: mapImageData.XRotate,
            XOffset: mapImageData.XOffset,
            YScale: mapImageData.YScale,
            YRotate: mapImageData.YRotate,
            YOffset: mapImageData.YOffset
        };

        const elevationService = new mapsData.ElevationService();

        elevationService.getElevationForLocations(
            {
                locations: [{ lat, lng }],
            },
            (results, status) => {
                if (status === "OK" && results[0]) {
                    if (mapImageData.XScale) {
                        dispatch(COMMON_SERVICES.getXYPointsInImageServices(mapImageXYPointsRequest));
                    }

                    const infoArray = [
                        `Latitude: ${lat}`,
                        `Longitude: ${lng}`,
                        `X Pixel: N/A`,
                        `Y Pixel: N/A`,
                        `Grey scale: N/A`,
                        `Min Elevation: ${mapImageData.MinElevation}`,
                        `Max Elevation: ${mapImageData.MaxElevation}`,
                        `Elevation: N/A`,
                        `Google Maps Api Elevation: ${results[0].elevation.toFixed(2)} meters`,
                        `NW: ${mapImageData.NwLat}, ${mapImageData.NwLng}`,
                        `NE: ${mapImageData.NeLat}, ${mapImageData.NeLng}`,
                        `SW: ${mapImageData.SwLat}, ${mapImageData.SwLng}`,
                        `SE: ${mapImageData.SeLat}, ${mapImageData.SeLng}`,
                        `Image Width: ${mapImageData.ImageWidth}`,
                        `Image Height: ${mapImageData.ImageHeight}`
                    ];

                    setHeightMapInfo(infoArray);
                }
            }
        );
    }

    const mapToElevation = (blueValue, minElevation, elevationRange) => {
        const normalizedValue = blueValue / 255; // Normalize the pixel value
        const mappedValue = elevationRange * normalizedValue; // Scale to elevation range
        return minElevation + mappedValue; // Add min elevation
    }

    const handleCloseHeightMapModal = () => {
        setOpenHeightMapModal(false);
    }

    const onIdle = (e) => {
        const map = e?.map;

        if (!map) return;

        const center = map.getCenter();

        if (!center) return;

        const newCenter = {
            lat: center.lat(),
            lng: center.lng(),
        };

        if (clickState?.state) {
            setDragCenter({
                lat: clickState.data.Latitude,
                lng: clickState.data.Longitude,
            });
        } else {
            setDragCenter(newCenter);
        }

        setMapReady(newCenter.lat != 30.20223435690779 && newCenter.lng != -81.39747201448188);
    }

    //#region Site Area
    const imagePreview = (item) => {
        var holeAreaType = {
            Tee: 0,
            Fairway: 1,
            Green: 2,
            Extents: 3,
        };

        dispatch(
            COMMON_SERVICES.getMapInformationServices(
                item.Course,
                item.Hole,
                typeHole.get() === settingsPoITypes.hole ? settingsPoITypes.approach : settingsPoITypes.hole,
                siteId.get()
            )
        );
        imageUrl.set(mapInformationData?.Data);
        imageHoleNo.set(item.Hole);
        courseNo.set(item.Course);
        if (typeHole.get() === undefined)
            typeHole.set(holeAreaType.green === settingsPoITypes.hole ? settingsPoITypes.approach : settingsPoITypes.hole);
        holeNum.set(item.Hole);
    }

    const handleEditCourseChange = (e) => {
        setCourseEditName(e?.target ? e.target.value : e);
        let data = siteSettingsData.Courses;
        let obj = data.find((o) => (o.Number === e?.target ? e.target.value : e));
        let holeNumber = obj?.HoleCount;
        setHoleCount(holeNumber);
    }

    const cancelDialogOpen = (e) => {
        if (e === "cancelModal") {
            if (isNewEditPolygon()) {
                setDiscardModalOnLeave(() => discardChangesForSiteArea(e));
            } else {
                if (editSiteSetup.get()) {
                    setOpenAreaWindow(false);
                    cancelModal(true);
                    setIsTempPolygon(false);

                    holePolygons.forEach((it) => it.setMap(null));
                    setTempSiteEdit([]);
                    editSelectedData?.setOptions({
                        editable: false,
                        fillOpacity: 0.2,
                    });
                } else {
                    setDiscardModalOnLeave(() => discardChangesForSiteArea(e));
                }
            }
        } else if (e === "handleEditClose") {
            if (modalState === "cog") {
                if (isNewEditCog()) {
                    setDiscardModalOnLeave(() => discardChangesForSiteArea(e));
                } else {
                    handleEditClose();
                }
            } else if (modalState === "poi") {
                if (isNewEditPoi()) {
                    setDiscardModalOnLeave(() => discardChangesForSiteArea(e));
                } else {
                    handleEditClose();
                }
            } else if (modalState === "tee") {
                if (isNewEditTee()) {
                    setDiscardModalOnLeave(() => discardChangesForSiteArea(e));
                } else {
                    handleEditClose();
                }
            } else if (modalState === undefined) {
                handleEditClose();
            }
        } else if (e === "cancelMarkers") {
            if ((addSelectType.get() === siteSettingsTypes.centerOfGreen && ourData.cog.length > 0) ||
                (addSelectType.get() === siteSettingsTypes.teeMarkers && ourData.tee.length > 0) ||
                (addSelectType.get() === siteSettingsTypes.pointOfInterest && ourData.poi.length > 0)) {
                setDiscardModalOnLeave(() => discardChangesForSiteArea(e));
            } else {
                cancelMarkers();
            }
        } else if (e === "cancelSiteAreaModal") {
            if (editSiteSetup.get()) {
                if (siteAreaSaveActiveButton) {
                    setDiscardModalOnLeave(() => discardChangesForSiteArea(e));
                } else {
                    setOpenSiteAreaWindow(false);
                    setIsTempPolygon(false);
                    editSelectedData?.setOptions({
                        editable: false,
                        fillOpacity: 0.2,
                    });
                }
            } else {
                setDiscardModalOnLeave(() => discardChangesForSiteArea(e));
            }
        }
    }

    const isNewEditPolygon = () => {
        if (editSiteSetup.get()) {
            let filterValue = finalDataState?.length > 0 && finalDataState[0]?.HoleAreas?.filter((item) => item.Id === indexId);

            if (isEditHole) {
                setOpenAreaWindow(false);
                if (isHole) {
                    holePolygons.forEach((it) => it.setMap(null));
                    setIsHole(false);
                    setIsEditHole(false);
                } else {
                    setIsEditHole(false);
                    areaPolygons.forEach((it) => it.setMap(null));
                }
            }

            if (filterValue === undefined) return;

            if ((filterValue.length &&
                (courseNameModel !== filterValue[0].Course ||
                    holeNoModel !== filterValue[0].Hole ||
                    courseTypeModel !== filterValue[0].Type)) ||
                isTempPolygon
            ) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    const isNewEditCog = () => {
        if (editSiteSetup.get()) {
            if (modalState === "cog") {
                let newDataTemp = JSON.parse(JSON.stringify(centerGreenDataState));
                let filterData =
                    newDataTemp &&
                    newDataTemp.lenght !== 0 &&
                    newDataTemp.filter((el) => {
                        return el?.Id === Number(editId);
                    });
                if (
                    filterData[0]?.Course !== courseEditName ||
                    filterData[0]?.Hole !== editHoleNo
                ) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    const isNewEditPoi = () => {
        if (editSiteSetup.get()) {
            if (modalState === "poi") {
                let newDataTemp = JSON.parse(JSON.stringify(pointsOfInterestDataState));
                let filterData =
                    newDataTemp &&
                    newDataTemp.lenght !== 0 &&
                    newDataTemp.filter((el) => {
                        return el?.Id === Number(editId);
                    });
                if (filterData[0]?.Course !== courseEditName ||
                    filterData[0]?.Type !== poiEditTypeCopy ||
                    filterData[0]?.Hole !== editHoleNo ||
                    filterData[0]?.LabelPosition !== poiEditPositionCopy
                ) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    const isNewEditTee = () => {
        if (editSiteSetup.get()) {
            if (modalState === "tee") {
                let newDataTemp = JSON.parse(JSON.stringify(teeMarkersDataState));
                let filterData =
                    newDataTemp &&
                    newDataTemp.lenght !== 0 &&
                    newDataTemp.filter((el) => {
                        return el?.Id === Number(editId);
                    });
                if (filterData[0]?.Course !== courseEditName ||
                    filterData[0]?.Hole !== editHoleNo ||
                    filterData[0]?.TeeMarkerSettingId !== teeEditCopy
                ) {
                    return true;
                }
            }
        }
    }

    const setDiscardModalOnLeave = (submitFunc, closeFunc) => {
        if (submitFunc) {
            setAlertModalHandleOnSubmit(() => submitFunc);
        } else {
            setAlertModalHandleOnSubmit(() => setAlertModalIsOpen(false));
        }

        if (closeFunc) {
            setAlertModalHandleOnClose(() => closeFunc);
        }

        setAlertModalTitle(t("Confirm"));
        setAlertModalContent(`${t("Discard_changes")}?`);
        setAlertModalIsOpen(true);
        setAlertModalValidation(false);
    }

    const discardChangesForSiteArea = (dialogCancelValue) => {
        setEditCogTeePoiSaveActiveButton(false);
        setAddCogTeePoiSaveActiveButton(false);
        setSiteSetupSaveActiveButton(false);
        setSiteAreaSaveActiveButton(false);
        setOpenAreaWindow(false);
        setOpenSiteAreaWindow(false);
        addSiteSetup.set(false);
        dialogCancelValue === "cancelSiteAreaModal" && cancelSiteAreaModal();
        dialogCancelValue === "cancelModal" && cancelModal();
        dialogCancelValue === "cancelMarkers" && cancelMarkers();
        dialogCancelValue === "handleEditClose" && handleEditClose();

        if (areaModified.get() && editSiteSetup.get()) {
            setTempSiteEdit([]);
            areaModified.set(false);
            setIsTempPolygon(false);

            resetPrevPolygon(
                siteSetupState,
                isSiteAreaPolygon,
                isHoleAreaPolygon,
                tempSiteData,
                siteAreaClickEventData,
                siteAreaClickEvent,
                indexId,
                mapData,
                mapsData,
                teesAreaPathState,
                teesPathCoordsState,
                fwysAreaPathState,
                fwysPathCoordsState,
                gmsAreaPathState,
                gmsPathCoordsState,
                extsAreaPathState,
                extsPathCoordsState,
                stgsAreaPathState,
                stgsPathCoordsState,
                removeRequiredHoleAreaPolygon,
                removeRequiredSiteAreaPolygon,
                addListenersOnEditAreaFinalPolygon,
                addListenersOnEditSiteAreaChangesPolygon,
                addListenersOnEditSiteAreaFinalPolygon,
                updateClickedSiteAreaPolygon,
                updateClickedHoleAreaPolygon,
                teesZoneDisplayed,
                fwysZoneDisplayed,
                gmsZoneDisplayed,
                extsZoneDisplayed,
                stgsZoneDisplayed
            );
        }

        areaModified.set(false);
        setAlertModalIsOpen(false);
    }

    const addListenersOnEditSiteAreaChangesPolygon = (data) => {
        mapsData.event.addListener(data, "mousedown", function () {
            mapsData.event.addListener(data.getPath(), "set_at", function () {
                var path = data.getPath();
                var bounds = new mapsData.LatLngBounds();
                for (var i = 0; i < path.length; i++) {
                    bounds.extend(path.getAt(i));
                }

                let arr = [];
                for (let i = 0; i < path.getLength(); i++) {
                    const xy = path.getAt(i);
                    arr.push({
                        Lat: xy.lat(),
                        Lon: xy.lng(),
                    });
                }

                setTempSiteEdit(arr);
                setTempPolygon(arr);
                setVerticesCount(arr.length);
                setIsTempPolygon(true);
                setSiteAreaSaveActiveButton(true);

                let exPoly = siteSetupData?.HoleAreas.find((item) => item.Id === data.indexID);

                if (JSON.stringify(getCordFromPoly(data)) === JSON.stringify(exPoly?.Polygon)) {
                    setSiteSetupSaveActiveButton(false);
                    setIsTempPolygon(false);
                    areaModified.set(false);
                } else {
                    setSiteSetupSaveActiveButton(true);
                    setIsTempPolygon(true);
                    areaModified.set(true);
                }
            });

            mapsData.event.addListener(data.getPath(), "insert_at", function () {
                var path = data.getPath();
                var bounds = new mapsData.LatLngBounds();
                for (var i = 0; i < path.length; i++) {
                    bounds.extend(path.getAt(i));
                }

                let arr = [];
                for (let i = 0; i < path.getLength(); i++) {
                    const xy = path.getAt(i);
                    arr.push({
                        Lat: xy.lat(),
                        Lon: xy.lng(),
                    });
                }

                setTempSiteEdit(arr);
                setTempPolygon(arr);
                setVerticesCount(arr.length);
                setIsTempPolygon(true);
                setSiteSetupSaveActiveButton(true);
                setSiteAreaSaveActiveButton(true);

                areaModified.set(true);
            });

            mapsData.event.addListener(data.getPath(), "remove_at", function () {
                let exPoly = siteSetupData?.HoleAreas.find((item) => item.Id === data.indexID);

                if (JSON.stringify(getCordFromPoly(data)) === JSON.stringify(exPoly?.Polygon)) {
                    setSiteSetupSaveActiveButton(false);
                    setIsTempPolygon(false);
                    areaModified.set(false);
                } else {
                    setSiteSetupSaveActiveButton(true);
                    setIsTempPolygon(true);
                    areaModified.set(true);
                }
            });
        });
    }

    const addListenersOnEditSiteAreaFinalPolygon = (data) => {
        mapsData.event.addListener(data, "click", function (e) {
            if (carPopupClickEvent.get()) {
                carPopupClickEvent.set(null);
                return;
            }
            if (areaModified.get()) {
                setIsSiteAreaPolygon(true);
                setSiteAreaClickEvent(e);
                setSiteAreaClickEventData(data);

                setDiscardModalOnLeave(discardChangesForSiteArea);
                return;
            } else {
                updateClickedSiteAreaPolygon(data, e);
            }

            const lat = e.latLng.lat();
            const lng = e.latLng.lng();

            drawMarker(lat,
                lng,
                addSiteSetup.get(),
                addSelectType.get(),
                setSiteSetupDialogBox,
                setOurData,
                showTeeMarkers,
                setOpenModel,
                showPointsOfInterest,
                siteSettingsTypes
            );
        });
        addListenersOnEditSiteAreaChangesPolygon(data);
    }

    const updateClickedSiteAreaPolygon = (data, e) => {
        setSiteAreaSaveActiveButton(false);
        setIsSiteAreaPolygon(false);

        if (editSiteSetup.get()) {
            let filterValue = siteSetupState?.length > 0 && siteSetupState[0]?.SiteAreas?.filter((item) => item.Id === data.indexID);

            setSiteSetupDialogBox({ lat: e.latLng?.lat(), lng: e.latLng?.lng() });

            setEditSelectedData((prevData) => {
                if (prevData?.indexID !== data.indexID) {
                    prevData?.setOptions({
                        editable: false,
                        fillOpacity: 0.2,
                    });
                }
            });

            setOpenAreaWindow(false);
            setIndexID(data.indexId);
            setTempSiteData(filterValue);
            setTempSiteId(filterValue);
            setTempPolygon(filterValue[0].Polygon);
            if (!verticesCount) setVerticesCount(filterValue[0].Polygon.length);
            setOpenSiteAreaWindow(true);

            var canEdit = (!isUserBasic(getUserRole && getUserRole?.Role) && !isUserReadOnly(getUserRole && getUserRole?.Role));

            data?.setOptions({
                editable: canEdit,
                fillOpacity: 0.6,
            });
            setEditSelectedData(data);
        }
    }

    const updateClickedHoleAreaPolygon = (data, e) => {
        let filterValue = siteSetupState?.length > 0 && siteSetupState[0]?.HoleAreas?.filter((item) => item.Id === data.indexID);

        setSiteSetupSaveActiveButton(false);
        setIsHoleAreaPolygon(false);
        setOpenSiteAreaWindow(false);
        setOpenAreaWindow(false);
        setIndexID(data.indexID);
        setTempSiteId(filterValue);
        setTempPolygon([...filterValue[0].Polygon]);

        if (!verticesCount)
            setVerticesCount(filterValue[0].Polygon.length);

        setCourseNameModel(filterValue[0].Course);
        courseNameHandleChange(filterValue[0].Course);
        setHoleNoModel(filterValue[0].Hole);
        setCourseTypeModel(filterValue[0].Type);
        courseTypeHandleChange(filterValue[0].Type);
        typeHole.set(filterValue[0].Type);

        if (editSiteSetup.get()) {
            setSiteSetupDialogBox({ lat: e.latLng?.lat(), lng: e.latLng?.lng() });

            setEditSelectedData((prevData) => {
                if (prevData?.indexID !== data.indexID) {
                    prevData?.setOptions({
                        editable: false,
                        fillOpacity: 0.2,
                    });
                }
            });
        }

        let imageData = {
            courseNumber: filterValue[0].Course,
            holeNumber: filterValue[0].Hole,
            siteIdValue,
        };

        imagePreview(imageData);
        if (editSiteSetup.get()) {
            var canEdit = (!isUserBasic(getUserRole && getUserRole?.Role) && !isUserReadOnly(getUserRole && getUserRole?.Role));

            setEditModel(false);
            if (filterValue.length) setOpenAreaWindow(true);
            data?.setOptions({
                editable: canEdit,
                fillOpacity: 0.6,
            });
        }
        setEditSelectedData(data);
        previousEditedPolygon.set(data);
    }

    const holeAreaDrawingEventListenerAdding = () => {
        var canEdit = (!isUserBasic(getUserRole && getUserRole?.Role) && !isUserReadOnly(getUserRole && getUserRole?.Role));

        var areaDrawingManager = mapsData &&
            new mapsData.drawing.DrawingManager({
                drawingMode: mapsData.drawing.OverlayType.POLYGON,
                cursor: "crosshair",
                drawingControl: false,
                polygonOptions: {
                    editable: canEdit,
                    suppressUndo: true,
                    clickable: false,
                    strokeColor: "#00FF00",
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    fillColor: "red",
                    cursor: "crosshair",
                },
                drawingControlOptions: {
                    position: mapsData.ControlPosition.TOP_CENTER,
                    drawingModes: [mapsData.drawing.OverlayType.POLYGON],
                },
            });
        areaDrawingManager?.setMap(mapData);
        setDrawAreaPolygon(areaDrawingManager);

        mapsData?.event.addListener(
            areaDrawingManager,
            "polygoncomplete",
            function (e) {
                var path = e.getPath();
                // find out the paths of this polygon
                var bounds = new mapsData.LatLngBounds();

                for (var i = 0; i < path.length; i++) {
                    bounds.extend(path.getAt(i));
                }

                const center = bounds.getCenter();

                setSiteSetupDialogBox({ lat: center.lat(), lng: center.lng() });

                let arr = [];
                // Iterate over the vertices.
                for (let i = 0; i < path.getLength(); i++) {
                    const xy = path.getAt(i);
                    arr.push({
                        lat: xy.lat(),
                        lon: xy.lng(),
                    });
                }
                setTempPolygon([...arr]);
                setVerticesCount(arr.length);
                setHolePolygons([e]);
                setOpenSiteAreaWindow(false);
                setOpenAreaWindow(true);
                courseNameHandleChange(1);
                areaDrawingManager.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
                areaModified.set(true);
                setIsHole(true);
                setIsEditHole(true);
            }
        );
    }

    const resetHoleAreaForm = () => {
        setCourseNameModel(1);
        setHoleNoModel(1);
        setCourseTypeModel(1);
    }

    const getCordFromPoly = (poly) => {
        let CurrentArr = [];
        if (poly.getPath().length > 1) {
            let vertices = poly.getPaths().getArray()[0];
            vertices.forEach((vertex) => {
                const lat = vertex.lat();
                const lng = vertex.lng();
                CurrentArr.push({
                    // Id: 0,
                    Lat: lat,
                    Lon: lng,
                });
            });
        }

        return CurrentArr;
    }

    const courseNameHandleChange = (e) => {
        setCourseNameModel(e?.target ? e.target.value : e);
        let data = siteSettingsData?.Courses;
        let obj = data?.find((o) => (o.Number === e?.target ? e.target.value : e));
        let holeNumber = obj.HoleCount;
        let firstTimeModalOpen = e?.target ? e.target.value : null;
        if (firstTimeModalOpen !== null) {
            setSiteSetupSaveActiveButton(true);
            areaModified.set(true);
        }
        setHoleCount(holeNumber);
    }

    const courseTypeHandleChange = (e) => {
        let firstTimeModalOpen = e?.target ? e.target.value : null;
        if (firstTimeModalOpen !== null) {
            setSiteSetupSaveActiveButton(true);
            areaModified.set(true);
        }
        setCourseTypeModel(e.target ? e.target.value : e);
    }

    const addListenersOnEditAreaFinalPolygon = (data) => {
        mapsData.event.addListener(data, "click", function (e) {
            if (carPopupClickEvent.get() !== null) {
                carPopupClickEvent.set(null);
                return;
            }
            if (areaModified.get()) {
                setIsHoleAreaPolygon(true);
                setSiteAreaClickEvent(e);
                setSiteAreaClickEventData(data);

                setDiscardModalOnLeave(discardChangesForSiteArea);
                return;
            } else {
                updateClickedHoleAreaPolygon(data, e);
            }

            const lat = e.latLng.lat();
            const lng = e.latLng.lng();

            drawMarker(lat,
                lng,
                addSiteSetup.get(),
                addSelectType.get(),
                setSiteSetupDialogBox,
                setOurData,
                showTeeMarkers,
                setOpenModel,
                showPointsOfInterest,
                siteSettingsTypes
            );
        });
        addListenersOnEditSiteAreaChangesPolygon(data);
    }

    const cancelSiteAreaModal = () => {
        setOpenSiteAreaWindow(false);
        if (addSiteSetup.get()) {
            siteAreaDrawingEventListenerAdding();
            areaPolygons.forEach((it) => it.setMap(null));
            setRemoveAddPolygon(true);
        }
    }

    const cancelModal = () => {
        if (addSiteSetup.get()) {
            holeAreaDrawingEventListenerAdding();
            setOpenAreaWindow(false);
            resetHoleAreaForm();
            if (isHole) {
                holePolygons.forEach((it) => it.setMap(null));
                setIsHole(false);
                setIsEditHole(false);
            } else {
                areaPolygons.forEach((it) => it.setMap(null));
                setIsEditHole(false);
            }
        } else {
            setOpenAreaWindow(false);
            setOpenSiteAreaWindow(false);
            editSelectedData?.setOptions({
                editable: false,
                fillOpacity: 0.2,
            });
        }
        resetHoleAreaForm();
    }

    const cancelMarkers = () => {
        if (addSelectType.get() === siteSettingsTypes.teeMarkers) {
            setOurData((prev) => ({
                ...prev,
                tee: [],
            }));
        } else if (addSelectType.get() === siteSettingsTypes.pointOfInterest) {
            setOurData((prev) => ({
                ...prev,
                poi: [],
            }));
        } else if (addSelectType.get() === siteSettingsTypes.centerOfGreen) {
            setOurData((prev) => ({
                ...prev,
                cog: [],
            }));
        }

        setOpenModel(false);
    }

    const onCancelInteraction = () => {
        if (modalState === "tee") {
            setTeeMarkersDataState(siteSetupState[0]?.TeeMarkers);
        } else if (modalState === "poi") {
            setPointsOfInterestDataState(siteSetupState[0]?.PointsOfInterest);
        } else if (modalState === "cog") {
            setCenterGreenDataState(siteSetupState[0]?.HoleDatas);
        }
    }

    const handleEditClose = (reason) => {
        if (reason && reason === "backdropClick") return;
        setEditModel(false);
        onCancelInteraction();
    }

    const removeRequiredHoleAreaPolygon = () => {
        let tempSiteSetupState = JSON.parse(JSON.stringify(siteSetupState));
        let tempHoleArea = tempSiteSetupState[0].HoleAreas?.find(
            (item) => item.Id === indexId
        );
        if (tempHoleArea?.Type === 0) {
            teesZoneDisplayed.filter((item, i) => {
                if (item?.indexID === indexId) {
                    item?.setMap(null);
                    teesZoneDisplayed.splice(i, 1);
                }
            });
        } else if (tempHoleArea?.Type === 1) {
            fwysZoneDisplayed.filter((item, i) => {
                if (item.indexID === indexId) {
                    item?.setMap(null);
                    fwysZoneDisplayed.splice(i, 1);
                }
            });
        } else if (tempHoleArea?.Type === 2) {
            gmsZoneDisplayed.filter((item, i) => {
                if (item.indexID === indexId) {
                    item?.setMap(null);
                    gmsZoneDisplayed.splice(i, 1);
                }
            });
        } else if (tempHoleArea?.Type === 3) {
            extsZoneDisplayed.filter((item, i) => {
                if (item.indexID === indexId) {
                    item?.setMap(null);
                    extsZoneDisplayed.splice(i, 1);
                }
            });
        }
    }

    const removeRequiredSiteAreaPolygon = () => {
        let tempSiteSetupState = JSON.parse(JSON.stringify(siteSetupState));
        let tempSiteArea = tempSiteSetupState[0].SiteAreas?.find(
            (item) => item.Id === tempSiteData[0]?.Id
        );
        if (tempSiteArea?.Type === 0) {
            stgsZoneDisplayed.filter((item, i) => {
                if (item.indexID === tempSiteData[0]?.Id) {
                    item?.setMap(null);
                    stgsZoneDisplayed.splice(i, 1);
                }
            });
        }
    }

    const siteAreaDrawingEventListenerAdding = () => {
        var canEdit = (!isUserBasic(getUserRole && getUserRole?.Role) && !isUserReadOnly(getUserRole && getUserRole?.Role));

        var siteAreaDrawingManager = mapsData &&
            new mapsData.drawing.DrawingManager({
                drawingMode: mapsData.drawing.OverlayType.POLYGON,
                drawingControl: false,
                polygonOptions: {
                    editable: canEdit,
                    clickable: false,
                    strokeColor: "#663a83",
                    strokeOpacity: 0.9,
                    fillOpacity: 0.2,
                    strokeWeight: 2,
                    fillColor: "#663a83",
                },
                drawingControlOptions: {
                    position: mapsData.ControlPosition.TOP_CENTER,
                    drawingModes: [mapsData.drawing.OverlayType.POLYGON],
                },
            });

        siteAreaDrawingManager?.setMap(mapData);
        setSiteDrawAreaPolygon(siteAreaDrawingManager);

        mapsData?.event.addListener(
            siteAreaDrawingManager,
            "polygoncomplete",
            function (e) {
                var path = e.getPath();
                // find out the paths of this polygon

                var bounds = new mapsData.LatLngBounds();
                for (var i = 0; i < path.length; i++) {
                    bounds.extend(path.getAt(i));
                }

                const center = bounds.getCenter();

                setSiteSetupDialogBox({ lat: center.lat(), lng: center.lng() });

                let arr = [];
                // Iterate over the vertices.
                for (let i = 0; i < path.getLength(); i++) {
                    const xy = path.getAt(i);
                    arr.push({
                        lat: xy.lat(),
                        lon: xy.lng(),
                    });
                }

                setTempPolygon([...arr]);
                setAreaPolygons([e]);
                setVerticesCount(arr.length);
                setOpenAreaWindow(false);
                setOpenSiteAreaWindow(true);
                courseNameHandleChange(1);
                siteAreaDrawingManager.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
                areaModified.set(true);
                setIsEditHole(true);
            }
        );
    }

    //#endregion Site Area

    const historyModalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "400px",
        width: "calc(100% -  40px)",
        bgcolor: "#fff",
        borderRadius: "5px",
        overflow: "hidden",
    }

    const popUpStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "600px",
        width: "100%",
        bgcolor: "rgb(255, 255, 255)",
        borderRadius: "5px",
        overflow: "hidden",
    }

    return (
        <>
            <FilterHeader className="for-map-filter-header">
                <div className="heightMapOpacityContainer" ref={opacityContainerRef} style={{ visibility: 'hidden' }}>
                    <input type="range" id="heightMapOpacitySlider" width={'30%'} ref={opacitySliderRef} />
                </div>

                <MapMobileMenu
                    site={site}
                    zoomToShowAll={zoomToShowAll}
                    setZoomToShowAll={setZoomToShowAll}
                    setSite={setSite}
                    showHoleMarker={showHoleMarker}
                    toggleShowHoleMarker={toggleShowHoleMarker}
                    handleOpen2={(e) => handleOpen2(e, setOpen2)}
                    handleToggle={() => setActiveCarList(!isActiveCarList)}
                    kmlLayerData={kmlLayerData}
                />
                <MapTopMenu
                    zoomToShowAll={zoomToShowAll}
                    setZoomToShowAll={setZoomToShowAll}
                    site={site}
                    setSite={setSite}
                    kmlLayerData={kmlLayerData}
                    showHoleMarker={showHoleMarker}
                    toggleShowHoleMarker={toggleShowHoleMarker}
                />
                {canAccessSiteSetup && (Math.round(siteSettingsData?.CenterPointLatitude) + Math.round(siteSettingsData?.CenterPointLongitude))
                    * (Math.round(siteSettingsData?.UpperLeftLatitude) + Math.round(siteSettingsData?.UpperLeftLongitude)) === 0
                    && <MapBottom
                        lat={lat}
                        lng={lng}
                        setLat={setLat}
                        setLng={setLng}
                        isValidLat={isValidLat}
                        isValidLng={isValidLng}
                        handleGoButtonClick={handleGoButtonClick}
                        handleSetSiteExtentOpen={() => setOpenSiteExtent(true)}
                    />}
                <MapSideMenu
                    handleOpen2={(e) => handleOpen2(e, setOpen2)}
                    handleToggle={() => setActiveCarList(!isActiveCarList)}
                />

                <MapLegend handleClose2={() => setOpen2(false)} open2={open2} />
            </FilterHeader>

            {!mapReady &&
                <Loader />
            }

            <div style={{ height: isMobile ? "93vh" : "100vh", width: "100%", position: "relative", visibility: mapReady ? "visible" : "hidden" }}>
                <APIProvider apiKey="AIzaSyBS7xNXe1Je5JAU3OToU_bxNuxDB0xGrtA" libraries={["marker"]} version="3.66">
                    <Map
                        mapId="d08571e1ea07a80a57dcf5a9"
                        style={{ width: "100%", height: "100%" }}
                        defaultZoom={14}
                        defaultCenter={dragCenter}
                        gestureHandling="greedy"
                        draggable={setting.draggable}
                        onIdle={onIdle}
                        onClick={(e) => drawMarker(e.detail.latLng.lat,
                            e.detail.latLng.lng,
                            addSiteSetup.get(),
                            addSelectType.get(),
                            setSiteSetupDialogBox,
                            setOurData,
                            showTeeMarkers,
                            setOpenModel,
                            showPointsOfInterest,
                            siteSettingsTypes
                        )}
                    >
                        <MapInitializer
                            mapTypeId={handleMapTypeId()}
                            setMap={setMap}
                            setMaps={setMaps}
                        />

                        {mapData && mapsData &&
                            <>
                                <CarMarkers
                                    carData={carData}
                                    mapData={mapData}
                                    mapsData={mapsData}
                                    setEditModel={setEditModel}
                                    zoomPosition={zoomPosition}
                                />

                                <SiteAreaMarkers
                                    mapData={mapData}
                                    mapsData={mapsData}
                                    teeMarkersDataState={teeMarkersDataState}
                                    setTeeMarkersDataState={setTeeMarkersDataState}
                                    pointsOfInterestDataState={pointsOfInterestDataState}
                                    setPointsOfInterestDataState={setPointsOfInterestDataState}
                                    centerGreenDataState={centerGreenDataState}
                                    setCenterGreenDataState={setCenterGreenDataState}
                                    setOpenModel={setOpenModel}
                                    setOpenAreaWindow={setOpenAreaWindow}
                                    setHoleCount={setHoleCount}
                                    holeNo={holeNo}
                                    imagePreview={imagePreview}
                                    setOpenSiteAreaWindow={setOpenSiteAreaWindow}
                                    setTempPolygon={setTempPolygon}
                                    teeMarkeSeetingId={teeMarkeSeetingId}
                                    setTeeMarkerSeetingId={setTeeMarkerSeetingId}
                                    ourData={ourData}
                                    setTempSiteEdit={setTempSiteEdit}
                                    setIsTempPolygon={setIsTempPolygon}
                                    setEditModel={setEditModel}
                                    setFinalDataState={setFinalDataState}
                                    setCarSnackbarInfo={setCarSnackbarInfo}
                                    setCTDModal={setCTDModal}
                                    showHoleMarker={showHoleMarker}
                                    poiTypeValue={poiTypeValue}
                                    poiPositionValue={poiPositionValue}
                                    teeValue={teeValue}
                                    holePolygons={holePolygons}
                                    areaPolygons={areaPolygons}
                                    editSelectedData={editSelectedData}
                                    courseNameModel={courseNameModel}
                                    holeNoModel={holeNoModel}
                                    siteSetupState={siteSetupState}
                                    teesAreaPathState={teesAreaPathState}
                                    teesPathCoordsState={teesPathCoordsState}
                                    fwysAreaPathState={fwysAreaPathState}
                                    fwysPathCoordsState={fwysPathCoordsState}
                                    gmsAreaPathState={gmsAreaPathState}
                                    gmsPathCoordsState={gmsPathCoordsState}
                                    extsAreaPathState={extsAreaPathState}
                                    extsPathCoordsState={extsPathCoordsState}
                                    stgsAreaPathState={stgsAreaPathState}
                                    stgsPathCoordsState={stgsPathCoordsState}
                                    addListenersOnEditAreaFinalPolygon={addListenersOnEditAreaFinalPolygon}
                                    addListenersOnEditSiteAreaChangesPolygon={addListenersOnEditSiteAreaChangesPolygon}
                                    addListenersOnEditSiteAreaFinalPolygon={addListenersOnEditSiteAreaFinalPolygon}
                                    teesZoneDisplayed={teesZoneDisplayed}
                                    fwysZoneDisplayed={fwysZoneDisplayed}
                                    gmsZoneDisplayed={gmsZoneDisplayed}
                                    extsZoneDisplayed={extsZoneDisplayed}
                                    stgsZoneDisplayed={stgsZoneDisplayed}
                                    holeAreaDrawingEventListenerAdding={holeAreaDrawingEventListenerAdding}
                                    resetHoleAreaForm={resetHoleAreaForm}
                                    siteDrawAreaPolygon={siteDrawAreaPolygon}
                                    drawAreaPolygon={drawAreaPolygon}
                                    setTeesZoneDisplayed={setTeesZoneDisplayed}
                                    setGmsZoneDisplayed={setGmsZoneDisplayed}
                                    setFwysZoneDisplayed={setFwysZoneDisplayed}
                                    setStgsZoneDisplayed={setStgsZoneDisplayed}
                                    setExtsZoneDisplayed={setExtsZoneDisplayed}
                                    snackbarState={snackbarState}
                                    setSnackbarState={setSnackbarState}
                                    setSiteSetupState={setSiteSetupState}
                                    setEditSelectedData={setEditSelectedData}
                                    setTeesAreaPathState={setTeesAreaPathState}
                                    setTeesPathCoords={setTeesPathCoords}
                                    setStgsAreaPathState={setStgsAreaPathState}
                                    setStgsPathCoords={setStgsPathCoords}
                                    setFwysAreaPathState={setFwysAreaPathState}
                                    setFwysPathCoords={setFwysPathCoords}
                                    setGmsAreaPathState={setGmsAreaPathState}
                                    setGmsPathCoords={setGmsPathCoords}
                                    setExtsAreaPathState={setExtsAreaPathState}
                                    setExtsPathCoords={setExtsPathCoords}
                                    removeAddPolygon={removeAddPolygon}
                                    cancelMarkers={cancelMarkers}
                                    setCourseNameModel={setCourseNameModel}
                                    setHoleNoModel={setHoleNoModel}
                                    setCourseTypeModel={setCourseTypeModel}
                                    clickWindowState={clickWindowState}
                                    carPopupClickEvent={carPopupClickEvent}
                                    setSetting={setSetting}
                                    setModalState={setModalState}
                                    setEditId={setEditId}
                                    setEditLatLng={setEditLatLng}
                                    setDeleteId={setDeleteId}
                                    setPoiEditTypeValue={setPoiEditTypeValue}
                                    setPoiEditTypeCopy={setPoiEditTypeCopy}
                                    setEditHoleNo={setEditHoleNo}
                                    handleEditCourseChange={handleEditCourseChange}
                                    setSiteSetupDialogBox={setSiteSetupDialogBox}
                                    siteAreaDrawingEventListenerAdding={siteAreaDrawingEventListenerAdding}
                                />
                            </>
                        }
                    </Map>
                </APIProvider>
            </div>

            {mapData && mapsData &&
                <>
                    <SiteArea
                        mapData={mapData}
                        mapsData={mapsData}
                        openSiteAreaWindow={openSiteAreaWindow}
                        verticesCount={verticesCount}
                        siteSetupDialogBox={siteSetupDialogBox}
                        setSiteSetupDialogBox={setSiteSetupDialogBox}
                        tempPolygon={tempPolygon}
                        siteAreaSaveActiveButton={siteAreaSaveActiveButton}
                        cancelDialogOpen={cancelDialogOpen}
                        tempSiteData={tempSiteData}
                        setOpenSiteAreaWindow={setOpenSiteAreaWindow}
                        removeRequiredSiteAreaPolygon={removeRequiredSiteAreaPolygon}
                        setSiteAreaSaveActiveButton={setSiteAreaSaveActiveButton}
                        openAreaWindow={openAreaWindow}
                        courseNameModel={courseNameModel}
                        editSelectedData={editSelectedData}
                        tempSiteId={tempSiteId}
                        tempSiteEdit={tempSiteEdit}
                        courseNameHandleChange={courseNameHandleChange}
                        holeNoModel={holeNoModel}
                        holeCount={holeCount}
                        setHoleCount={setHoleCount}
                        courseTypeModel={courseTypeModel}
                        courseTypeHandleChange={courseTypeHandleChange}
                        siteSetupSaveActiveButton={siteSetupSaveActiveButton}
                        siteSetupState={siteSetupState}
                        setTempPolygon={setTempPolygon}
                        cancelMarkers={cancelMarkers}
                        setSiteSetupSaveActiveButton={setSiteSetupSaveActiveButton}
                        setOpenAreaWindow={setOpenAreaWindow}
                        removeRequiredHoleAreaPolygon={removeRequiredHoleAreaPolygon}
                        setHoleNoModel={setHoleNoModel}
                        openModel={openModel}
                        setOpenModel={setOpenModel}
                        holeNo={holeNo}
                        setHoleNo={setHoleNo}
                        teeValue={teeValue}
                        setTeeValue={setTeeValue}
                        poiTypeValue={poiTypeValue}
                        setPoiTypeValue={setPoiTypeValue}
                        poiPositionValue={poiPositionValue}
                        setPoiPositionValue={setPoiPositionValue}
                        addCogTeePoiSaveActiveButton={addCogTeePoiSaveActiveButton}
                        setAddCogTeePoiSaveActiveButton={setAddCogTeePoiSaveActiveButton}
                        ourData={ourData}
                        setOurData={setOurData}
                        teeMarkersDataState={teeMarkersDataState}
                        setTeeMarkersDataState={setTeeMarkersDataState}
                        teeMarkeSeetingId={teeMarkeSeetingId}
                        editModel={editModel}
                        pointsOfInterestDataState={pointsOfInterestDataState}
                        setPointsOfInterestDataState={setPointsOfInterestDataState}
                        courseEditName={courseEditName}
                        setCourseEditName={setCourseEditName}
                        editHoleNo={editHoleNo}
                        setEditHoleNo={setEditHoleNo}
                        editId={editId}
                        setTeeEditCopy={setTeeEditCopy}
                        setEditCogTeePoiSaveActiveButton={setEditCogTeePoiSaveActiveButton}
                        imagePreview={imagePreview}
                        centerGreenDataState={centerGreenDataState}
                        setCenterGreenDataState={setCenterGreenDataState}
                        setEditModel={setEditModel}
                        setPoiEditTypeCopy={setPoiEditTypeCopy}
                        setPoiEditPositionCopy={setPoiEditPositionCopy}
                        editCogTeePoiSaveActiveButton={editCogTeePoiSaveActiveButton}
                        teeEditValue={teeEditValue}
                        setTeeEditValue={setTeeEditValue}
                        modalState={modalState}
                        handleEditCourseChange={handleEditCourseChange}
                        poiEditTypeValue={poiEditTypeValue}
                        setPoiEditTypeValue={setPoiEditTypeValue}
                        poiEditPositionValue={poiEditPositionValue}
                        setPoiEditPositionValue={setPoiEditPositionValue}
                        deleteId={deleteId}
                        editLatLng={editLatLng}
                        isNewEditPolygon={isNewEditPolygon}
                        isNewEditPoi={isNewEditPoi}
                        isNewEditTee={isNewEditTee}
                        isNewEditCog={isNewEditCog}
                    />

                    <ActionZones
                        mapData={mapData}
                        mapsData={mapsData}
                        setZoomPosition={setZoomPosition}
                        clickToDrivefeature={clickToDrivefeature}
                        setTilted={setMapTilted}
                        setActiveCarList={setActiveCarList}
                        setDiscardModalOnLeave={setDiscardModalOnLeave}
                        alertModalTitle={alertModalTitle}
                        setAlertModalTitle={setAlertModalTitle}
                        alertModalContent={alertModalContent}
                        setAlertModalContent={setAlertModalContent}
                        alertModalIsOpen={alertModalIsOpen}
                        setAlertModalIsOpen={setAlertModalIsOpen}
                        alertModalValidation={alertModalValidation}
                        setAlertModalValidation={setAlertModalValidation}
                        alertModalHandleOnSubmit={alertModalHandleOnSubmit}
                        setAlertModalHandleOnSubmit={setAlertModalHandleOnSubmit}
                        alertModalHandleOnClose={alertModalHandleOnClose}
                    />

                    <CarInfo
                        mapReady={mapReady}
                        clickState={clickState}
                        setClickState={setClickState}
                        snackbarState={snackbarState}
                        carSnackbarInfo={carSnackbarInfo}
                        CTDModal={CTDModal}
                        setCTDModal={setCTDModal}
                        mapData={mapData}
                        mapsData={mapsData}
                        carData={carData}
                        setCarData={setCarData}
                        setSite={setSite}
                        setSnackbarState={setSnackbarState}
                        clickToDrivefeature={clickToDrivefeature}
                        zoomToShowAll={zoomToShowAll}
                        setZoomToShowAll={setZoomToShowAll}
                        isActiveCarList={isActiveCarList}
                        setActiveCarList={setActiveCarList}
                        CarList={CarList}
                        displayCars={displayCars}
                    />

                    <Modal
                        open={openHeightMapModal && isHeightMapShowing}
                        onClose={handleCloseHeightMapModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        sx={{ zIndex: 10001 }}
                    >
                        <Box sx={historyModalStyle}>
                            <PopUpContainer>
                                <h2>{t("Height_Map_Info")}</h2>
                                <p> {heightMapInfo && heightMapInfo?.map((line, index) => (
                                    <div key={index}>{line}</div>
                                ))}
                                </p>
                                <div className="action-btn">
                                    <button
                                        onClick={handleCloseHeightMapModal}
                                    >
                                        {t("Ok")}
                                    </button>
                                </div>
                            </PopUpContainer>
                        </Box>
                    </Modal>

                    <Modal
                        open={openSiteExtent}
                        onClose={() => setOpenSiteExtent(false)}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        sx={{ zIndex: 10001 }}
                    >
                        <Box sx={popUpStyle}>
                            <PopUpContainer>
                                <h2>{t("Confirm")}</h2>
                                <p>{t("SiteExtent_Confirm")}</p>
                                <div className="action-btn">
                                    <button
                                        className="primary"
                                        onClick={handleSetSiteExtentClick}
                                        variant="contained"
                                    >
                                        {t("Yes")}
                                    </button>
                                    <button onClick={() => setOpenSiteExtent(false)}>
                                        {t("No")}
                                    </button>
                                </div>
                            </PopUpContainer>
                        </Box>
                    </Modal>

                    <MapControlButtons
                        baseType={mapBaseType}
                        setBaseType={setMapBaseType}
                        showTerrain={showMapTerrain}
                        setShowTerrain={setShowMapTerrain}
                        setLastSelectedBaseType={setLastSelectedMapBaseType}
                        showLabels={showMapLabels}
                        setShowLabels={setShowMapLabels}
                    />

                    <MapTiltButton
                        mapData={mapData}
                        mapsData={mapsData}
                        mapSideNavTabState={mapSideNavTabState}
                        tilted={mapTilted}
                        setTilted={setMapTilted}
                        siteId={siteIdValue} />
                </>
            }
        </>
    );
}